import * as XLSX from "xlsx";

const ExcelService = {  

    exportEntite( collections, collectionName){
        let formattedName = collectionName.replace(/\s+/g, "_").replace(/[\[\]\:*?/\\]/g, "");
        if (formattedName.length > 31) formattedName = formattedName.substring(0, 31);
        const nomfichier = "Entités_collection_"+formattedName ;

         // Créer un nouveau workbook
        const wb = XLSX.utils.book_new();

        // En-têtes du tableau pour les collections
        const wsDatacollection = [["ID", "Nom de l'entité", "Type", "NB.Fichiers", "ID de la collection", "Surface ( en km² )", "Latitude", "Longitude","Longueur ( en km )", "Rayon ( en km )", "Observation ( texte brut )", "Observation ( format html )"]];
        
        collections.forEach((collection) => {
            // Remplir les lignes des collections
            let latitude = '';
            let longitude = '';
            let distance = '';
            let radiusc = '';
            let surface = '';
            if(collection.geojson?.properties?.type == 'marker' || collection.geojson?.properties?.type == 'textMarker'){
                const [lng, lat] = collection.geojson.geometry.coordinates; 
                latitude = lat;
                longitude = lng;
            }
            else if(collection.geojson?.properties?.type == 'polyline'){
                const coord =  collection.geojson.geometry.coordinates; 
                let meters = 0;
                for (let i = 0; i < coord.length - 1; i++) {
                    const [startlng, startlat] = coord[i];
                    const [endlng, endlat] = coord[i + 1];
                    const segment = turf.lineString([
                        [startlng, startlat],
                        [endlng, endlat]
                    ]);
                    meters = meters + turf.length(segment, { units: 'meters' });
                }                 
                distance = (meters / 1000).toFixed(4) ;
            }
            else if(collection.geojson?.properties?.type == 'circle'){
                const [lngc, latc] = collection.geojson.geometry.coordinates; 
                latitude = latc;
                longitude = lngc;
                const center = [lngc, latc];
                const radius = collection.geojson?.properties?.options?.radius; // en mètres
                const circlePolygon = turf.circle(center, radius, { steps: 64, units: 'meters' });                
                const areaM2 = turf.area(circlePolygon); // en m²
                surface = (areaM2 / 1_000_000).toFixed(4);

                const rayonc = collection.geojson?.properties?.options?.radius;
                radiusc = (rayonc / 1000).toFixed(4);

            }
            else{
                const polygonGeoJSON = collection.geojson;
                const surfaceM2 = turf.area(polygonGeoJSON);
                surface = (surfaceM2 / 1e6).toFixed(4);

            }

            wsDatacollection.push([
                collection.id || "",
                collection.geojson.properties?.titre || "",
                collection.geojson.properties?.type || "",
                collection.geojson.properties?.nb_fichier || "",
                collection.geojson.properties?.collection_id || "",
                surface,
                latitude,
                longitude,
                distance,
                radiusc,
                this.getPlainTextFromObservation(collection?.observation),
                collection?.observation
            ]);
        });

        // Créer la sheet "Mes Collections"
        const wsCollections = XLSX.utils.aoa_to_sheet(wsDatacollection);
        this.autoFitColumns(wsCollections, wsDatacollection);
        XLSX.utils.book_append_sheet(wb, wsCollections, formattedName);

        // Écrire le fichier
        XLSX.writeFile(wb, nomfichier+".xlsx");
    },
  
    exportCollection( collections,type){
        const titre = type === 'collection' ? "Mes collections" : "Mes collections partagées";
        const nomfichier = type === 'collection' ? "collections" : "collections_partagées";

         // Créer un nouveau workbook
        const wb = XLSX.utils.book_new();

        // En-têtes du tableau pour les collections
        const wsDatacollection = [["Identifiant", "Nom de la collection", "Nombre d'entités"]];
        
        collections.forEach((collection) => {
            // Remplir les lignes des collections
            wsDatacollection.push([
                collection.id || "",
                collection.nom_affiche || "",
                collection.nb_entite|| ""
            ]);
        });

        // Créer la sheet "Mes Collections"
        const wsCollections = XLSX.utils.aoa_to_sheet(wsDatacollection);
        this.autoFitColumns(wsCollections, wsDatacollection);
        XLSX.utils.book_append_sheet(wb, wsCollections, titre);

        collections.forEach((collection,index) => {
            const features = collection.geojson?.features || [];
            // En-têtes du tableau pour chaque entité
            const wsData = [["ID", "Nom de l'entité", "Type", "NB.Fichiers", "ID de la collection", "Surface ( en km² )", "Latitude", "Longitude","Longueur ( en km )", "Rayon ( en km )", "Observation ( texte brut )", "Observation ( format html )"]];
            
            // Remplir les lignes des entités
            features.forEach((feature) => {
                let latitude = '';
                let longitude = '';
                let distance = '';
                let radiusc = '';
                let surface = '';
                if(feature?.properties?.type == 'marker' || feature?.properties?.type == 'textMarker'){
                    const [lng, lat] = feature.geometry.coordinates; 
                    latitude = lat;
                    longitude = lng;
                }
                else if(feature?.properties?.type == 'polyline'){
                    const coord =  feature.geometry.coordinates; 
                    let meters = 0;
                    for (let i = 0; i < coord.length - 1; i++) {
                        const [startlng, startlat] = coord[i];
                        const [endlng, endlat] = coord[i + 1];
                        const segment = turf.lineString([
                            [startlng, startlat],
                            [endlng, endlat]
                        ]);
                        meters = meters + turf.length(segment, { units: 'meters' });
                    }                 
                    distance = (meters / 1000).toFixed(4) ;
                }
                else if(feature?.properties?.type == 'circle'){
                    const [lngc, latc] = feature.geometry.coordinates; 
                    latitude = latc;
                    longitude = lngc;
                    const center = [lngc, latc];
                    const radius = feature?.properties?.options?.radius; // en mètres
                    const circlePolygon = turf.circle(center, radius, { steps: 64, units: 'meters' });                
                    const areaM2 = turf.area(circlePolygon); // en m²
                    surface = (areaM2 / 1_000_000).toFixed(4);

                    const rayonc = feature?.properties?.options?.radius;
                    radiusc = (rayonc / 1000).toFixed(4);

                }
                else{
                    const polygonGeoJSON = feature;
                    const surfaceM2 = turf.area(polygonGeoJSON);
                    surface = (surfaceM2 / 1e6).toFixed(4);
                }
                
                wsData.push([
                    feature.id || "",
                    feature.properties?.titre || "",
                    feature.properties?.type || "",
                    feature.properties?.nb_fichier || "",
                    feature.properties?.collection_id || "",
                    surface,
                    latitude,
                    longitude,
                    distance,
                    radiusc,
                    this.getPlainTextFromObservation(feature.properties?.observation),
                    feature.properties?.observation
                ]);
            });

            // Créer une sheet
            const ws = XLSX.utils.aoa_to_sheet(wsData);
            this.autoFitColumns(ws, wsData);
            // Nom de la sheet = nom_affiche ou nom_collection
            let baseName = (collection.nom_affiche || collection.nom_collection || `Sheet${collection.id}`).replace(/[:\\/?*\[\]]/g, "");
            baseName = baseName.substring(0, 25);
            // Ajoute un prefixe unique (1_, 2_, etc.)
            let sheetName = `${index + 1}_${baseName}`;
            XLSX.utils.book_append_sheet(wb, ws, sheetName.substring(0, 31)); // max 31 chars
        });

        // Écrire le fichier
        XLSX.writeFile(wb, nomfichier+".xlsx");
    },

    autoFitColumns(ws, data) {
        const colWidths = data[0].map((_, colIndex) =>
            ({ wch: Math.max(...data.map(row => (row[colIndex] ? row[colIndex].toString().length : 0))) + 2 })
        );
        ws['!cols'] = colWidths;
    },
  
    getPlainTextFromObservation(html) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
    },
      
  }
  
  export default ExcelService;